import banner from "../../../courses/module-2/img8.png";

const modulo8_pt = {
  courseId: "cripto-blockchain",
  id: "modulo-8",
  title: "🧩 MÓDULO 8: Glossário e Mini Conceitos Essenciais",
  estimatedDuration: "30 minutos",
  format: "Leitura + glossário + atividade de revisão",
  bannerUrl: banner,
  sections: [
    {
      id: "objetivos",
      navLabel: "Objetivos",
      title: "🎯 O que veremos neste módulo?",
      content: [
        "Este módulo foi criado para te ajudar a revisar os conceitos essenciais apresentados ao longo do curso. Aqui você encontrará definições, exemplos reais, lembretes curtos e links úteis para tirar qualquer dúvida e se preparar com segurança para a avaliação final.",
      ],
    },
    {
      id: "glosario",
      navLabel: "Glossário",
      title: "🧠 Glossário ampliado – Revisão geral",
      content: [
        {
          type: "paragraph",
          text: "🔗 Blockchain",
        },
        {
          type: "list",
          items: [
            "É um registro público, digital e descentralizado onde todas as transações são armazenadas.",
            "Cada bloco contém informações e está ligado ao anterior, formando uma “cadeia”.",
            "Exemplo: Bitcoin e Ethereum usam blockchain para registrar quem possui qual criptomoeda.",
          ],
        },
        {
          type: "paragraph",
          text: "💸 Criptomoedas",
        },
        {
          type: "list",
          items: [
            "São moedas digitais que funcionam sem bancos ou governos.",
            "Exemplos: BTC (Bitcoin), ETH (Ethereum), SOL (Solana), ADA (Cardano), XLM (Stellar).",
            "Podem ser usadas para pagamentos, investimentos ou acesso a serviços digitais.",
          ],
        },
        {
          type: "paragraph",
          text: "🟡 Stablecoins",
        },
        {
          type: "list",
          items: [
            "Criptomoedas cujo valor está atrelado a um ativo estável, como o dólar.",
            "Exemplos: USDT, USDC, DAI.",
            "Ideais para evitar a volatilidade das outras criptos.",
          ],
        },
        {
          type: "paragraph",
          text: "🌐 Web3",
        },
        {
          type: "list",
          items: [
            "Uma nova geração da internet que coloca o controle nas mãos dos usuários.",
            "Baseia-se em blockchain, descentralização e propriedade digital.",
            "Diferenças:",
          ],
        },
        {
          type: "orderedList",
          items: [
            "Web 1.0: apenas leitura",
            "Web 2.0: ler e escrever",
            "Web 3.0: ler, escrever e possuir",
          ],
        },
        {
          type: "paragraph",
          text: "🔐 Wallets (carteiras digitais)",
        },
        {
          type: "list",
          items: [
            "Aplicativos usados para armazenar e movimentar criptomoedas.",
            "Tipos:",
          ],
        },
        {
          type: "orderedList",
          items: [
            "Custodial (a plataforma guarda suas chaves, ex.: Binance)",
            "Non-custodial (você tem controle total, ex.: Vesseo, MetaMask)",
          ],
        },
        {
          type: "list",
          items: ["Sempre protegidas por uma seed phrase (frase-semente)."],
        },
        {
          type: "paragraph",
          text: "🔏 Seed Phrase",
        },
        {
          type: "list",
          items: [
            "É sua chave mestra: uma lista de 12 ou 24 palavras que permite recuperar sua wallet se você perder o dispositivo.",
            "Exemplo: chuva – tomate – trem – vazio – folha…",
            "Nunca compartilhe nem salve online!",
          ],
        },
        {
          type: "paragraph",
          text: "🔍 Exploradores de blockchain",
        },
        {
          type: "list",
          items: [
            "Sites onde você pode consultar transações, blocos e carteiras de forma pública.",
            "Exemplos:",
          ],
        },
        {
          type: "orderedList",
          items: ["Etherscan.io", "Solscan.io", "Stellar.expert"],
        },
        {
          type: "paragraph",
          text: "🛠️ Contratos inteligentes (Smart Contracts)",
        },
        {
          type: "list",
          items: [
            "Programas que rodam automaticamente na blockchain quando certas condições são cumpridas.",
            "Exemplo: um contrato de empréstimo que libera o pagamento assim que você deposita a quantia exigida.",
          ],
        },
        {
          type: "paragraph",
          text: "⚙️ Taxas de gás (Gas fees)",
        },
        {
          type: "list",
          items: [
            "Taxas pagas para processar uma transação na blockchain.",
            "Algumas redes têm taxas altas (Ethereum), enquanto outras são mais baratas (Stellar, Polygon).",
          ],
        },
        {
          type: "paragraph",
          text: "👤 KYC (Know Your Customer)",
        },
        {
          type: "list",
          items: [
            "Processo obrigatório em muitas plataformas para verificar sua identidade.",
            "Ajuda a prevenir fraudes, mas implica compartilhar seus dados pessoais.",
          ],
        },
        {
          type: "paragraph",
          text: "🔥 Termos-chave no Web3",
        },
        {
          type: "table",
          headers: ["Termo", "Definição breve"],
          rows: [
            ["DeFi", "Finanças descentralizadas sem intermediários"],
            [
              "NFT",
              "Token não fungível: arte digital, ingressos, itens únicos na blockchain",
            ],
            [
              "DAO",
              "Organização autônoma e descentralizada governada por seus membros",
            ],
            [
              "Staking",
              "“Congelar” suas criptos para ajudar a rede e ganhar recompensas",
            ],
            [
              "Airdrop",
              "Recompensa gratuita recebida por participar ou se registrar em um projeto",
            ],
            [
              "Farming",
              "Fornecer liquidez a um protocolo DeFi em troca de juros",
            ],
            [
              "Token",
              "Representação digital de um ativo ou utilidade, podendo existir em várias redes",
            ],
          ],
        },
      ],
    },
    {
      id: "prevencion",
      navLabel: "Como evitar golpes",
      title: "⚠️ Como evitar golpes",
      content: [
        {
          type: "list",
          items: [
            "Verifique sempre a URL antes de conectar sua carteira.",
            "Nunca compartilhe sua seed phrase ou chaves privadas.",
            "Desconfie de promessas de dinheiro fácil.",
            "Use plataformas confiáveis e pesquise seu histórico.",
          ],
        },
      ],
    },
    {
      id: "extra",
      navLabel: "Nota extra",
      title: "📌 Nota extra: Não confunda rede, token e criptomoeda",
      content: [
        {
          type: "paragraph",
          text: "Uma criptomoeda pode existir em mais de uma rede.",
        },
        {
          type: "paragraph",
          text: "Exemplo: USDC existe nas redes Ethereum, Polygon, Solana e Stellar.",
        },
        {
          type: "paragraph",
          text: "Se você enviar pela rede errada, pode perder seus fundos.",
        },
        {
          type: "paragraph",
          text: "✅ Antes de enviar:",
        },
        {
          type: "list",
          items: [
            "Confira a rede correta (ERC-20, SPL etc.)",
            "Verifique se o destinatário aceita essa rede",
            "Confirme que o token é compatível",
          ],
        },
      ],
    },
    {
      id: "lecturas",
      navLabel: "Recursos úteis",
      title: "📚 Recursos úteis",
      content: [
        {
          type: "link",
          href: "https://www.binance.com/pt-BR/academy/glossary",
          text: "Glossário da Binance Academy",
        },
        {
          type: "link",
          href: "https://central.ajuda.mercadobitcoin.com.br/helpcenter/mbcentral/portal/22/article/1047789636",
          text: "Stellar Quest – Aprenda e ganhe XLM",
        },
      ],
    },
    {
      id: "actividad",
      navLabel: "Atividade final",
      title: "✍ Atividade final do módulo",
      content: [
        "No seu caderno, escreva um resumo com seus 10 conceitos favoritos do curso.",
      ],
    },
    {
      id: "frase",
      navLabel: "Frase do dia",
      title: "🧠 Frase do dia",
      content: [
        "“Dominar o básico é o que vai te permitir ir longe no mundo cripto.”",
      ],
    },
  ],
};

export default modulo8_pt;
